import { Grid, IconButton, Tooltip } from '@material-ui/core'
import React from 'react'
import CustomEntityAboutCard from './CustomEntityAboutCard'
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph'
import { EntityHasSubcomponentsCard, EntityLinksCard } from '@backstage/plugin-catalog'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router'

export default function CustomOverviewContent() {

    const navigate=useNavigate();

  return (
    <Grid container spacing={3} alignItems="stretch">
    {/* {entityWarningContent} */}
    <Grid item xs={12}>
      <div>
        <Tooltip title='Back'>
        <IconButton onClick={()=>{navigate(-1)}}>
            <ArrowBackIosIcon/>
        </IconButton>
        </Tooltip>
      </div>
    </Grid>
    <Grid item md={6}>
      {/* <EntityAboutCard variant="gridItem" /> */}
      <CustomEntityAboutCard/>
    </Grid>
    <Grid item md={6} xs={12}>
      <EntityCatalogGraphCard variant="gridItem" height={400} />
    </Grid>

    {/* <Grid item md={4} xs={12}>
      <EntityLinksCard />
    </Grid>
    <Grid item md={8} xs={12}>
      <EntityHasSubcomponentsCard variant="gridItem" />
    </Grid> */}
  </Grid>
  )
}
